import { render } from "./AssistenteDock.vue?vue&type=template&id=36522224&scoped=true&ts=true"
import script from "./AssistenteDock.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssistenteDock.vue?vue&type=script&setup=true&lang=ts"

import "./AssistenteDock.vue?vue&type=style&index=0&id=36522224&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36522224"],['__file',"src/typescript/modulos/governanca/AssistentePontotel/apresentacao/acoplamento/AssistenteDock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36522224"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36522224', __exports__)) {
    api.reload('36522224', __exports__)
  }
  
  module.hot.accept("./AssistenteDock.vue?vue&type=template&id=36522224&scoped=true&ts=true", () => {
    api.rerender('36522224', render)
  })

}


export default __exports__